var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.017 2.812)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.984 1.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.849,5.163A2.432,2.432,0,1,0,4.889,7.535v5.8a2.427,2.427,0,0,0,0,4.741v5.8a2.432,2.432,0,1,0,1.054,0v-5.8a2.427,2.427,0,0,0,0-4.741v-5.8A2.435,2.435,0,0,0,7.849,5.163ZM6.795,26.242a1.378,1.378,0,1,1-1.378-1.378A1.378,1.378,0,0,1,6.795,26.242Zm0-10.54a1.378,1.378,0,1,1-1.378-1.378A1.378,1.378,0,0,1,6.795,15.7Z",
    transform: "translate(-2.984 -1.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.969,1.188V9.07H28.588V1.188ZM27.535,8.017H11.024V2.242H27.535Z",
    transform: "translate(-3.14 -1.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.313,
    height: 1.054,
    transform: "translate(9.732 2.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.815,
    height: 1.054,
    transform: "translate(9.732 4.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.969,19.851H28.588V11.969H9.969Zm1.055-6.829H27.535V18.8H11.024Z",
    transform: "translate(-3.14 -1.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.313,
    height: 1.054,
    transform: "translate(9.732 12.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.815,
    height: 1.054,
    transform: "translate(9.732 15.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.969,30.631H28.588V22.75H9.969ZM11.024,23.8H27.535v5.774H11.024Z",
    transform: "translate(-3.14 -1.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.313,
    height: 1.054,
    transform: "translate(9.732 23.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.815,
    height: 1.054,
    transform: "translate(9.732 25.73)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks-icon.86236657b63ff312039baf861651b916.svg";
export { ForwardRef as ReactComponent };